module.exports = __webpack_public_path__ + "img/63.42039db3.png";